import React, { useEffect, useState } from "react";
import Header from "./containers/Header/Header";
import Footer from "./containers/Footer/Footer";
import Creator from "./containers/Page/Creator";
import OrderConfirmation from "./containers/Page/OrderConfirmation";
import OrderForm from "./containers/Page/OrderForm";
import { Route, Switch, useLocation } from "react-router-dom";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import Desktop from "./components/Responsive/Desktop";
import useDesktop from "./components/Responsive/useDesktop";
import { ProjectActions } from "./reducers/project/actionsNames";
import { State } from "./reducers/rootReducer";
import ProjectHistory from "./containers/Page/ProjectHistory";
import ProjectsCart from "./containers/Page/ProjectsCart";
import { IProject } from "./reducers/project";
import { useFetch } from "./hooks/useFetch";

function App() {
  const location = useLocation();
  const loading = useSelector((state: State) => state.project.contentLoading);
  const desktop = useDesktop();
  const dispatch = useDispatch();

  const [_, request] = useFetch<IProject>("/project/", {} as any, {
    method: "GET",
    body: null,
  });

  const [_cart, requestCart] = useFetch<{
    id: string;
    projects: IProject[];
  }>("/cart/", {} as any, {
    method: "GET",
    body: null,
  });

  useEffect(() => {
    const history = window.localStorage.getItem("history");
    const cart = window.localStorage.getItem("cart");

    if (history) {
      const h: IProject[] = JSON.parse(history);

      h.map(async (h) => {
        const r = await request({}, h.id);
      });
      dispatch({
        type: ProjectActions.LoadHistory,
        history: h,
      });
    }

    if (cart) {
      requestCart({}, cart).then((c) => {
        dispatch({ type: ProjectActions.UpdateCart, cart: c });
      });
    }
  }, []);

  useEffect(() => {
    dispatch({ type: ProjectActions.FetchContent });
  }, []);

  useEffect(() => {
    dispatch({ type: ProjectActions.SetLoaded, loaded: false });
  }, [location.key]);

  return (
      <div
          key={String(loading)}
          style={{ display: "flex", height: "100vh", flexDirection: "column" }}
      >
        <Header />
        <Fade desktop={desktop}>
          <SwitchTransition>
            <CSSTransition
                key={location.key || "location"}
                timeout={{ enter: 300, exit: 0 }}
                classNames={"fade"}
            >
              <div
                  style={
                    !(
                        location.pathname === "/" ||
                        location.pathname === "" ||
                        location.pathname.length > 30
                    )
                        ? { height: desktop ? "100%" : "unset" }
                        : {
                          height: desktop ? "100%" : "unset",
                          display: "inline-flex",
                          width: "100%",
                        }
                  }
              >
                <Switch location={location}>
                  <Route exact={true} path={"/"} component={Creator} />
                  <Route exact={true} path={"/order"} component={OrderForm} />
                  <Route exact={true} path={"/cart"} component={ProjectsCart} />
                  <Route
                      exact={true}
                      path={"/history"}
                      component={ProjectHistory}
                  />
                  <Route
                      exact={true}
                      path={"/confirmation"}
                      component={OrderConfirmation}
                  />
                  <Route exact={true} path={"/:id"} component={Creator} />
                </Switch>
              </div>
            </CSSTransition>
          </SwitchTransition>
        </Fade>
        <Desktop>
          <Footer />
        </Desktop>
      </div>
  );
}

const Fade = styled.div<{ desktop?: boolean }>`
  height: calc(100vh - ${({ desktop }) => (desktop ? "135" : "75")}px);

  .fade-enter {
    opacity: 0.2;
  }

  .fade-enter.fade-enter-active {
    opacity: 1;
    transition: opacity 300ms ease-in;
  }

  .fade-exit {
    opacity: 1;
  }

  .fade-exit.fade-exit-active {
    opacity: 0.2;
    transition: opacity 300ms ease-in;
  }
`;

export default App;
